import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { I18nModule } from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule } from "@spartacus/storefront";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EditUserComponent } from "./edit-user.component";
import { KbMyAccountModule } from "../../kb-myAccount/kb-my-account.module";
import { KbMyOwnPartNumbersModule } from "../../kb-myAccount/kb-MyOwnPartNumbers/kbMyOwnPartNumbers.module";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { DeleteUserConfirmDialogComponent } from "../delete-user-confirm-dialog/delete-user-confirm-dialog.component";
import { UserRightsDialogComponent } from "../user-rights-dialog/user-rights-dialog.component";
import { KbCustomerIdDropdownModule } from "../../kb-myAccount/kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module";
import { KbMyAccountLeftSideNavModule } from "../../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module";

@NgModule({
 imports:[
  CommonModule,
  FormsModule,
  PageLayoutModule,
  OutletModule,
  OutletRefModule,
  PageSlotModule,
  I18nModule,
  KbMyAccountLeftSideNavModule,
  ReactiveFormsModule,
  KbMyOwnPartNumbersModule,
  MatDialogModule,
  MatIconModule,
  MatButtonModule,
 ],
 providers:[ 
  ],
 declarations:[EditUserComponent],
})
export class EditUserModule {

}
